import _toConsumableArray from "/builds/frontend/fm-official/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/builds/frontend/fm-official/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { once as E } from "../../../utils/once.js";
import { disposables as v } from "../../../utils/disposables.js";
import { match as p } from "../../../utils/match.js";

function f(t) {
  var _t$classList;

  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }

  t && e.length > 0 && (_t$classList = t.classList).add.apply(_t$classList, e);
}

function g(t) {
  var _t$classList2;

  for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    e[_key2 - 1] = arguments[_key2];
  }

  t && e.length > 0 && (_t$classList2 = t.classList).remove.apply(_t$classList2, e);
}

var T = function (n) {
  return n.Ended = "ended", n.Cancelled = "cancelled", n;
}(T || {});

function c(t, e) {
  var n = v();
  if (!t) return n.dispose;

  var _getComputedStyle = getComputedStyle(t),
      d = _getComputedStyle.transitionDuration,
      a = _getComputedStyle.transitionDelay,
      _map = [d, a].map(function (i) {
    var _i$split$filter$map$s = i.split(",").filter(Boolean).map(function (r) {
      return r.includes("ms") ? parseFloat(r) : parseFloat(r) * 1e3;
    }).sort(function (r, l) {
      return l - r;
    }),
        _i$split$filter$map$s2 = _slicedToArray(_i$split$filter$map$s, 1),
        _i$split$filter$map$s3 = _i$split$filter$map$s2[0],
        o = _i$split$filter$map$s3 === void 0 ? 0 : _i$split$filter$map$s3;

    return o;
  }),
      _map2 = _slicedToArray(_map, 2),
      s = _map2[0],
      u = _map2[1];

  if (s + u !== 0) {
    var i = [];
    i.push(n.addEventListener(t, "transitionrun", function (o) {
      o.target === o.currentTarget && (i.splice(0).forEach(function (r) {
        return r();
      }), i.push(n.addEventListener(t, "transitionend", function (r) {
        r.target === r.currentTarget && (e("ended"), i.splice(0).forEach(function (l) {
          return l();
        }));
      }), n.addEventListener(t, "transitioncancel", function (r) {
        r.target === r.currentTarget && (e("cancelled"), i.splice(0).forEach(function (l) {
          return l();
        }));
      })));
    }));
  } else e("ended");

  return n.add(function () {
    return e("cancelled");
  }), n.dispose;
}

function C(t, e, n, d) {
  var a = n ? "enter" : "leave",
      s = v(),
      u = d !== void 0 ? E(d) : function () {},
      m = p(a, {
    enter: function enter() {
      return e.enter;
    },
    leave: function leave() {
      return e.leave;
    }
  }),
      i = p(a, {
    enter: function enter() {
      return e.enterTo;
    },
    leave: function leave() {
      return e.leaveTo;
    }
  }),
      o = p(a, {
    enter: function enter() {
      return e.enterFrom;
    },
    leave: function leave() {
      return e.leaveFrom;
    }
  });
  return g.apply(void 0, [t].concat(_toConsumableArray(e.enter), _toConsumableArray(e.enterTo), _toConsumableArray(e.enterFrom), _toConsumableArray(e.leave), _toConsumableArray(e.leaveFrom), _toConsumableArray(e.leaveTo), _toConsumableArray(e.entered))), f.apply(void 0, [t].concat(_toConsumableArray(m), _toConsumableArray(o))), s.nextFrame(function () {
    g.apply(void 0, [t].concat(_toConsumableArray(o))), f.apply(void 0, [t].concat(_toConsumableArray(i))), c(t, function (r) {
      return r === "ended" && (g.apply(void 0, [t].concat(_toConsumableArray(m))), f.apply(void 0, [t].concat(_toConsumableArray(e.entered)))), u(r);
    });
  }), s.dispose;
}

export { T as Reason, C as transition };